import React from 'react';
import cx from 'classnames';

import { MirrorService } from 'services/MirrorService';

import { getCurrentLogo } from './utils';

import css from './logo.module.sass';

type PropTypes = {
  dark?: boolean;
  hideBottomLine?: boolean;
  small?: boolean;
  className?: string;
  isSidebar?: boolean;
};

export const Logo: React.FC<PropTypes> = ({
  dark = false,
  hideBottomLine = false,
  small = false,
  isSidebar = false,
  className,
}) => {
  let width = small ? '140px' : '150px';
  let height = '25px';

  const LogoIcon = getCurrentLogo({
    isDark: dark,
  });

  const formatSiteName = (siteName: string) => {
    if (siteName.length > 14 && siteName.includes('-')) {
      const siteNameParts = siteName.split('-');

      return `${siteNameParts[0][0]}-${siteNameParts[1]}`;
    }

    return siteName;
  };

  if (MirrorService.isMePlusYou) {
    width = '119px';
    height = '37px';
  }
  if (MirrorService.isMeamo) {
    width = '69px';
    height = '37px';
  }
  if (MirrorService.isMatchess) {
    width = '115px';
    height = '26px';
  }
  if (MirrorService.isPpl2ppl) {
    width = '101px';
    height = '29px';
  }
  if (MirrorService.isTheunite) {
    width = '100px';
    height = '21px';
  }
  if (MirrorService.isFinderSingles) {
    width = '139px';
    height = '29px';
  }
  if (MirrorService.isJoyFinder) {
    width = '124px';
    height = '22px';
  }
  if (MirrorService.isFlirtGuru) {
    width = '129px';
    height = '30px';
  }
  if (MirrorService.isFlirtDiscovery) {
    width = '89px';
    height = '34px';
  }
  if (MirrorService.isAdventureRelation) {
    width = '107px';
    height = '25px';
  }
  if (MirrorService.isLocalsDate) {
    width = '154px';
    height = '26px';
  }
  if (MirrorService.isLustStation) {
    width = '154px';
    height = '26px';
  }
  if (MirrorService.isLocalsJoy) {
    width = '119px';
    height = '37px';
  }
  if (MirrorService.isDreamsDate) {
    width = '96px';
    height = '26px';
  }
  if (MirrorService.isNeverAlones) {
    width = '83px';
    height = '30px';
  }
  if (MirrorService.isDateaSoul) {
    width = '129px';
    height = '21px';
  }
  if (MirrorService.isDateaSoulmate) {
    width = '134px';
    height = '20px';
  }
  if (MirrorService.isYourLove4Life) {
    width = '76px';
    height = '32px';
  }
  if (MirrorService.isRelationshipNest) {
    width = '76px';
    height = '32px';
  }
  if (MirrorService.isCupidKeys) {
    width = '76px';
    height = '32px';
  }
  if (MirrorService.isAmourPulse) {
    width = '76px';
    height = '32px';
  }
  if (MirrorService.isMyConnectly) {
    width = '76px';
    height = '32px';
  }
  if (MirrorService.isTenderTalkers) {
    width = '76px';
    height = '32px';
  }
  if (MirrorService.isTiamo) {
    width = '63px';
    height = '18px';
  }
  if (MirrorService.isSweatHeartSoul) {
    width = '122px';
    height = '14px';
  }
  if (MirrorService.isLinkamora) {
    width = isSidebar ? '143px' : '138px';
    height = isSidebar ? '67px' : '21px';
  }
  if (MirrorService.isFlirtiveo) {
    width = '132px';
    height = '20px';
  }
  if (MirrorService.isTendrilink) {
    width = '121px';
    height = '29px';
  }
  if (MirrorService.isChateluna) {
    width = '118px';
    height = '29px';
  }
  if (MirrorService.isGetParamour) {
    width = '125px';
    height = '19px';
  }
  if (MirrorService.isTripToLove) {
    width = '100px';
    height = '23px';
  }

  return (
    <>
      {LogoIcon && (
        <LogoIcon width={width} height={height} className={className} />
      )}

      {!LogoIcon && MirrorService.isMidSite && (
        <div
          className={cx(css.textLogo, { [css.whiteLogo]: !dark })}
          style={{ height }}
        >
          {formatSiteName(MirrorService.siteName)}
        </div>
      )}

      {!hideBottomLine && (
        <div
          className={cx(css.bottomLine, {
            [css.bottomLineLight]: !dark,
          })}
        />
      )}
    </>
  );
};
